var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { FormControlImpl } from './form-control';
import { ControlImpl } from './control';
import { ValidationErrorHandler } from './validation-error-handler';
var FormGroupImpl = /** @class */ (function (_super) {
    __extends(FormGroupImpl, _super);
    function FormGroupImpl(key, validations, _parent, _validators) {
        if (_validators === void 0) { _validators = []; }
        var _this = _super.call(this, key) || this;
        _this._parent = _parent;
        _this._validators = _validators;
        _this.isControlValidations = function (value) {
            return Array.isArray(value) === true;
        };
        var _a = _this.mapValidations(validations), controls = _a.controls, value = _a.value;
        _this._controls = controls;
        _this._value = value;
        return _this;
    }
    Object.defineProperty(FormGroupImpl.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormGroupImpl.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    FormGroupImpl.prototype.addValidator = function (validator) {
        this._validators.push(validator);
        return this;
    };
    FormGroupImpl.prototype.get = function (key) {
        return this._controls[key];
    };
    FormGroupImpl.prototype.patchValue = function (value, emit) {
        for (var key in value) {
            if (Object.prototype.hasOwnProperty.call(value, key)) {
                var _ = value[key];
                if (_ !== undefined) {
                    this.value[key] = _;
                    this.get(key).setValue(this.value[key]);
                }
            }
        }
        this.emitValue(emit);
        this.emitValidationState(emit);
        return this;
    };
    FormGroupImpl.prototype.removeValidator = function (validator) {
        this._validators = this._validators.filter(function (v) { return v !== validator; });
        return this;
    };
    FormGroupImpl.prototype.reset = function (value, emit) {
        if (value === void 0) { value = null; }
        this._value = value;
        this.markPristine();
        this.markUntouched();
        this.updateStatus();
        this.emitState(emit);
        this.emitValue(emit);
        this.emitValidationState(emit);
        return this;
    };
    FormGroupImpl.prototype.setValue = function (value, emit) {
        return this.patchValue(value, emit);
    };
    FormGroupImpl.prototype.validate = function () {
        var e_1, _a;
        if (this.dirty === true) {
            var handler_1 = new ValidationErrorHandler();
            try {
                for (var _b = __values(this._validators), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var validator = _c.value;
                    var result = validator(this);
                    handler_1.addErrors(result);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            Object.values(this._controls).forEach(function (control) {
                control.validate();
                handler_1.addErrors(control.errors, control.key);
            });
            this._errors = handler_1.getErrors();
            this._valid = handler_1.isValid();
            this.updateStatus();
            this.emitValidationState();
        }
        else {
            this._errors = null;
            this._valid = true;
        }
        return this._errors;
    };
    FormGroupImpl.prototype.mapValidations = function (validations) {
        var _this = this;
        var controls = {};
        var value = {};
        for (var key in validations) {
            if (Object.prototype.hasOwnProperty.call(validations, key)) {
                var o = validations[key];
                var control = void 0;
                if (this.isControlValidations(o)) {
                    control = this.mapControl(key, o);
                    control.onChange(function () {
                        _this.markDirty();
                        _this.update();
                        _this.validate();
                        _this.emitValue();
                    });
                    controls[key] = control;
                }
                else {
                    control = new FormGroupImpl(key, o, this);
                    control.onChange(function () {
                        _this.update();
                        _this.validate();
                        _this.emitValue();
                    });
                }
                control.onStateChange(function (state) {
                    var changed = false;
                    if (_this.dirty === false && state.dirty) {
                        _this.markDirty();
                        changed = true;
                    }
                    if (_this.touched === false && state.touched) {
                        _this.markTouched();
                        changed = true;
                    }
                    if (changed) {
                        _this.emitState();
                    }
                });
                controls[key] = control;
                value[key] = null;
            }
        }
        return {
            controls: controls,
            value: value,
        };
    };
    FormGroupImpl.prototype.mapControl = function (key, validators) {
        return new FormControlImpl(key, this, validators);
    };
    FormGroupImpl.prototype.update = function () {
        var formValue = this._value;
        Object.values(this._controls).forEach(function (control) {
            formValue[control.key] = control.value;
        });
    };
    FormGroupImpl.prototype.updateStatus = function () {
        // TODO add pending when implementing async validators
        if (this._valid === true) {
            this._validationState = 'valid';
        }
        else if (this._valid === false) {
            this._validationState = 'invalid';
        }
    };
    return FormGroupImpl;
}(ControlImpl));
export { FormGroupImpl };
//# sourceMappingURL=data:application/json;base64,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